"use client";

import Link from "next/link";
// import Image from "next/image";
import { flattenMenuList, menuList } from "@/app/data";
import { useParams, usePathname } from "next/navigation";
import { getBreadCrumbPaths } from "@/app/_lib/index";
import React from "react";
import { clsx } from "clsx";

export function MainTitle({
  title = "档案阅读",
  pathname,
}: {
  title: string;
  pathname?: string;
}) {
  return (
    <div className="h-[42px] w-full bg-[#ecf0f6]">
      <div className="w-[130px] h-full border-l-4  border-red-600  bg-[#07408e] flex items-center justify-center">
        {pathname ? (
          <Link
            href={pathname}
            className="text-center text-xl text-white font-bold"
          >
            {title}
          </Link>
        ) : (
          <div className="text-center text-xl text-white font-bold">
            {title}
          </div>
        )}
      </div>
    </div>
  );
}

export function SubTitle() {
  let pathname = usePathname();
  const { detailId } = useParams();
  pathname = detailId ? pathname.replace(`/${detailId}`, "") : pathname;

  const current = flattenMenuList.find((menu) => {
    return menu.link === pathname;
  })!;

  return (
    <div className="h-[46px] w-[860px] bg-[#f4f4f4]">
      <div className="w-[130px] h-full border-x-1 border-x-[#ddd] border-t-2 border-t-[#07408e] bg-white flex items-center justify-center">
        {current?.name}
      </div>
    </div>
  );
}

export function BreadCrumb({ detailPage = false }: { detailPage?: boolean }) {
  const { detailId } = useParams();
  const path = detailId
    ? usePathname().replace(`/${detailId}`, "")
    : usePathname();

  if (path === "/") return null;
  const segments = getBreadCrumbPaths(path);

  const navLinks = segments
    .map((seg) => flattenMenuList.filter((m) => m.link == seg))
    .flat();

  return (
    <div
      className={clsx(
        "h-[50px] text-[14px]/[50px] mb-[15px] pl-[30px] border-b-[1px] border-[#d1d1d1] bg-[url('/imgs/location.png')] bg-[6px_center] bg-no-repeat",
        {
          "bg-[16px_center] pl-[40px]": detailPage,
        }
      )}
    >
      <span>您当前所在位置：</span>
      {navLinks.map((m, index) => (
        <React.Fragment key={m.link}>
          <Link
            className="hover:text-[#d40100]"
            href={m?.children?.length ? m.children[0].link : m.link}
          >
            {m.name}
          </Link>
          <span className={clsx(index == navLinks.length - 1 ? "hidden" : "")}>
            &nbsp;&gt;&nbsp;
          </span>
        </React.Fragment>
      ))}
      {detailId && <span>&nbsp;&gt;&nbsp;正文</span>}
    </div>
  );
}

export function More() {
  return (
    <div className="flex justify-between px-[10px] mb-[8px] text-[#333] text-[16px]/[40px] border-b-[1px] border-dashed">
      <span className="font-bold">黑白影像</span>
      <span className="text-[12px]">
        <span>更多</span>
        <span>&gt;&gt;</span>
      </span>
    </div>
  );
}
